export default {
  app: {
    title: 'Airatis Vision',
    logoutButton: 'Déconnexion',
    adminButton: 'Admin',
    homeButton: 'Acceuil',
  },
  errors: {
    error403: 'Vous n’avez pas l’autorisation d’accéder à cette page, veuillez contacter le support',
    error404: 'La page que vous avez demandée n’existe pas',
    error500: 'L’application a rencontré une erreur, veuillez réessayer ultérieurement',
  },
  airports: {
    selectAirportMessage: 'Veuillez choisir un aéroport',
    noAirportsMessage: 'Vous n’avez accès a aucun aéroport, veuillez contacter le support',
  },
  detectionReports: {
    noDetectionMessage: "Il n'y a pas de détection pour cet aéroport",
    noDetectionUnidentifiedMessage: "Il n'y a pas encore de détection d'aéronef non identifié pour cet aéroport",
    mainReportTitle: 'Rapports de détection',
    reportIdentifiedTitle: 'Détecté le {{date}}\nImmatriculation : {{registration}} - Mouvement : {{movement}}',
    reportUnidentifiedTitle: 'Détecté le {{date}}',
    downloadVideo: 'Télécharger video',
    downloadImage: 'Télécharger image',
    invoiceRequest: 'Facturer',
    editReport: 'Modifier',
    archiveReport: 'Archiver',
    actionTitle: 'Options',
    cancelAction: 'Annuler',
    editReportMessage: "Vous pouvez modifier l'immatriculation de l'aéronef identifié",
    reportIdentifiedMessage: 'Immatriculation trouvée avec {{confidence}}% de confiance',
    reportUnidentifiedMessage: 'Aucune identification trouvée pour cette détection',
    reportMessageWithPCLA: 'PCL A activé',
    reportMessageWithPCLB: 'PCL B activé',
    filterStartDate: 'Date début',
    filterEndDate: 'Date fin',
    previousPage: 'Page précédente',
    nextPage: 'Page suivante',
    movementTypes: {
      TAKING_OFF: 'Décollage',
      LANDING: 'Atterrissage',
      LOW_PASS: 'Passage bas',
      TOUCH_AND_GO: 'Touch and go',
      ROLLING_ON_TRACK: 'Roulage sur piste',
      UNKNOWN: 'Inconnu',
    },
    reportsLoading: 'Plus de rapports de détections sont en cours de chargement',
    identifiedReportsTabTitle: 'Aéronefs identifiés',
    unidentifiedReportsTabTitle: 'Aéronefs non identifiés',
    archivedReportsTabTitle: 'Rapport archivés',
    downloadOnGoingMessage: 'Téléchargement des vidéos en cours, veuillez patienter',
  },
}
